/* AUTO-GENERATED from src/sm-i18n.js by scripts/build-bundle.mjs — do not edit by hand. */
(function () {
  function createI18n({ locale, fallback = 'de', assetBase, fetchImpl, urls }) {
    const doFetch = fetchImpl || ((...a) => fetch(...a));
    let dict = {};
    let fallbackDict = {};
    // Prefer the versioned URL rendered by Liquid (asset_url → includes ?v=<hash>).
    // Falling back to the unversioned assetBase path lets the CDN serve a stale,
    // possibly-empty cache — so urls[locale] must win whenever it is present.
    function urlFor(loc) {
      return (urls && urls[loc]) || `${assetBase}/sm-i18n.${loc}.json`;
    }
    async function load() {
      dict = await doFetch(urlFor(locale))
        .then((r) => (r.ok ? r.json() : {})).catch(() => ({}));
      if (locale !== fallback) {
        fallbackDict = await doFetch(urlFor(fallback))
          .then((r) => (r.ok ? r.json() : {})).catch(() => ({}));
      }
    }
    function dig(obj, key) {
      return key.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);
    }
    function t(key, vars) {
      const val = dig(dict, key) ?? dig(fallbackDict, key) ?? key;
      if (typeof val !== 'string') return key;
      return vars
        ? val.replace(/\{(\w+)\}/g, (_, k) =>
            (vars != null && Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : ''))
        : val;
    }
    return { t, load, get locale() { return locale; } };
  }

  window.SM_I18N = createI18n({
    locale: window.SM_LOCALE || 'de',
    fallback: 'de',
    assetBase: window.SM_ASSET_BASE || '',
    urls: window.SM_I18N_URLS,
  });
  window.SM_I18N_READY = window.SM_I18N.load();
})();
